export const formatDueDateresp = (resp) => {
    console.log(resp)
    let ordersField = resp?.outputField?.ordersField[0];
    let formattedResp = {};
    formattedResp.GetDueDateStatus = ordersField?.messageField?.toUpperCase();
    formattedResp.DueDates = ordersField.dueDatesField?.dueDateField.map(a => a.valueField);
    formattedResp.DueDateIntervals = generateDueDateInterval(ordersField.dueDatesField?.dueDateField);
    formattedResp.ShowCovidRestriction = "Y";
    // let  techInstallValue
    formattedResp.techOptionFields = resp?.outputField?.applicableDuedateOptionsField;
    formattedResp.showTechInstall = resp?.outputField?.applicableDuedateOptionsField?.length > 0;
    formattedResp.dispatchInfoField = resp?.outputField?.dispatchInfoField;
    console.log(formattedResp)
    return formattedResp;
}

export const generateDueDateInterval = (dueDateField) => {
    let duedateIntervalList = [];
    for (let i = 0; i < dueDateField?.length; i++) {
        let intervalobj = [];
        intervalobj.push(dueDateField[i].valueField);
        if (dueDateField[i].timeSlotsField) {
            for (let j = 0; j < dueDateField[i].timeSlotsField?.length; j++) {
                const timeSlotsField = dueDateField[i].timeSlotsField[j];
                let timeSlotArr = [];
                timeSlotArr.push(timeSlotsField.intervalField?.replace('Anytime Between ', ''));
                timeSlotArr.push(timeSlotsField.codeField);
                intervalobj.push(timeSlotArr);
            }
        }
        duedateIntervalList.push(intervalobj);
    }
    console.log(duedateIntervalList)
    return duedateIntervalList;
};

export const isNoSsnChecked = (props) => {
    const { soleOwner, partnership1, partnership2, customerType } = props.creditCheck;
    if (customerType === "SoleOwner") {
        return !soleOwner.isNoSsn;
    } else if (customerType === "Partner") {
        return (!partnership1.isNoSsn || !partnership2.isNoSsn);
    }
    return true;
}